import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { SlickSliderStyled } from './SlickSliderStyled';

const SlickSlider = ({ slideChangeEvent, sliderRef, sliderSettings = {}, children}) => {
  const settings = {
    dots: true,
    dotsClass: 'slick-dots',
    infinite: true,
    speed: 500,
    useCSS: true,
    useTransform: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    arrows: true,
    autoPlay: false,
    autoPlaySpeed: 3000,
    centerMode: false,
    centerPadding: '0',
    className: '',
    draggable: true,
    initialSlide: 0,
    rows: 1,
    touchMove: true,
    variableWidth: false,
    vertical: false,
    ...sliderSettings,
  };
  return (
    <>
    <SlickSliderStyled>
      <Slider ref={sliderRef} beforeChange={slideChangeEvent} {...settings}>
        {children}
      </Slider>
    </SlickSliderStyled>
    </>
  );
};

SlickSlider.propTypes = {
  slideChangeEvent: PropTypes.any,
  sliderRef: PropTypes.any,
  sliderSettings: PropTypes.object,
  children: PropTypes.any,
  isCartPromotion: PropTypes.bool,
};
SlickSlider.defaultProps = {
  isCartPromotion : false,
}
export default SlickSlider;
